export default {
  error: s => s.error,
  message: s => s.message,
  contact: s => s.contact,
  contactLoading: s => s.contactLoading,
  policyLinks: s => s.policyLinks,
  policyLinksLoading: s => s.policyLinksLoading,
  branding: s => s.branding,
  brandingLoading: s => s.brandingLoading,
  checkout: s => s.checkout,
  checkoutLoading: s => s.checkoutLoading,
  loading: s => s.loading,
  settings: s => s.settings,
  settingsLoaded: s => s.settingsLoaded,
  oauthUrl: s => s.oauthUrl,
  amazonState: s => s.amazonState,
  allow_pay_later: state => state.checkout.allow_pay_later,
  contact_name_required: state => state.checkout.contact_name_required,
  contact_phone_required: state => state.checkout.contact_phone_required,
  reseller_markup: state => state.reseller_markup,
  markupLoading: state => state.markupLoading,
  basicSettings: state => state.basicSettings,
  reseller_markup: state => state.reseller_markup
}